import React from 'react';
import { MAP_COMPACT_SIZE } from '@/experiences/sales-portal/components/map/constants';
import { Skeleton } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

export const CompactMapSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <Skeleton
      borderRadius={theme.sk.radii.radiusLarge}
      height={MAP_COMPACT_SIZE}
      variant="rect"
      width={MAP_COMPACT_SIZE}
    />
  );
};
